import { ArrowDownIcon, ArrowUpIcon } from "@/assets/icons";
import { Stack } from "@altimateai/lego";
import { Button, Typography } from "@altimateai/lego";
import { ReactNode, useState } from "react";

interface Props {
  title: ReactNode;
  howToText: string;
  howToContent: ReactNode;
}
const AccordionTitle = ({ title, howToText, howToContent }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const handleClick = () => {
    setExpanded(prev => !prev);
  };
  return (
    <div>
      <Stack justify="between">
        {title}
        <Button variant="link" onClick={handleClick}>
          {howToText} {expanded ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </Button>
      </Stack>
      {expanded ? (
        <div>
          <Typography variant="subheading">{howToText}</Typography>
          {howToContent}
        </div>
      ) : null}
    </div>
  );
};

export default AccordionTitle;
